import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { addToCart } from 'Redux/ducks/cart';
import store, { history } from 'Redux/store';
import useViewport from 'Hooks/useViewport';
import AddToCart from 'Components/Utility/Buttons/AddToCart';

const ProductEditionsAddToCartBtn = ({
  product,
  allSlugs,
  className,
}) => {
  const [addingToBasket, setAddingToBasket] = useState(false);

  const { slug } = product;

  const disableButton = addingToBasket;

  const inCart = allSlugs.includes(slug);

  const clickAddToCart = async () => {
    setAddingToBasket(true);

    await store.dispatch(addToCart(history.push, product._id, 0));

    return setAddingToBasket(false);
  };

  const { isAboveMd } = useViewport();

  return (
    <AddToCart
      addingToBasket={addingToBasket}
      inCart={inCart}
      disabled={disableButton}
      oldStyle={isAboveMd}
      className={className}
      onClick={inCart ? () => history.push('/cart') : () => clickAddToCart()}
    />
  );
};

ProductEditionsAddToCartBtn.propTypes = {
  product: PropTypes.shape({}),
  allSlugs: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

ProductEditionsAddToCartBtn.defaultProps = {
  product: null,
  allSlugs: [],
  className: '',
};


const mapStateToProps = ({
  cart: { allSlugs },
}) => ({
  allSlugs,
});

export default connect(mapStateToProps)(ProductEditionsAddToCartBtn);
